import styled from 'styled-components'
import headerImage from '../../images/head_img.jpg';

export const ImageSection = styled.div `
  .btn{
    margin: 15px;
  }
  @media (max-width: 500px) {
    height: 550px;
    .btn{
      margin-top: 15px;
    }
  }
  text-align: center;
  position: relative;
  height: ${props => props.height};
  width: 100%;
  background: no-repeat url(${props => props.background});
  background-size:     cover;
  background-position: center center;
  opacity: ${props => props.opacity};
  max-height: 800px;
  @media (max-width: 1000px) {
    height: 80vw;
    min-height: 545px;
  }
`
ImageSection.defaultProps = {
    background: headerImage,
    height: "800px",
    opacity: 1
}

export const ImageHeader = styled.div `
text-align: center;
position: relative;
height: ${props => props.height}px;
width: 100%;
background: no-repeat,linear-gradient(0deg, rgba(0,0,0,0.5032387955182073) 0%, rgba(0,0,0,0.5788690476190477) 100%), url(${props => props.background});
background-size:     cover;
background-position: center center;
opacity: ${props => props.opacity};
display: flex;
align-items: center;
justify-content: center;
@media (max-width: 500px) {
  height: 250px;
}
`
ImageHeader.defaultProps = {
    background: headerImage,
    height: 350,
    opacity: 1
}

export const ImageHeading = styled.h2 `
margin-top: 0px;
text-shadow: 0 2px 3px rgba(0,0,0,.2);
@media (max-width: 500px) {
  padding-top: 100px;
}
padding-top: 0px;
`


export const WappenLogo = styled.div `
    img{
      width:35%;
      max-width:345px;
      min-width:250px;
    }
    top: 100px;
    z-index: 1;
    width: 100%;
    text-align: center;
    position: absolute;
`

export const H1Padding = styled.h1 `
  @media (max-width: 900px) {
    font-size: 18px;
    display: none;
  }
  letter-spacing: 0px;
  padding-top:15px;
  padding-bottom:15px;
`



// WEBPACK FOOTER //
// /src/components/OnePager/ImageSectionStyle.js